/* FASHIONSHUBS — product page & wishlist features */
(function () {
  var LS = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var money = function (cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var card = function (p) {
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
    return '<a class="fh-card" href="/products/' + p.handle + '"><div class="fh-card__img">' +
      (img ? '<img src="' + img + '" alt="' + (p.vendor + ' ' + p.title).replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
      '</div><div class="fh-card__vendor">' + p.vendor + '</div><div class="fh-card__title">' + p.title +
      '</div><div class="fh-card__price">' + money(p.price) + '</div></a>';
  };
  var fetchProducts = function (handles) {
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) { return list.filter(Boolean); });
  };

  /* Wishlist */
  var WL = 'fh_wishlist';
  var syncWish = function () {
    var list = LS.get(WL);
    document.querySelectorAll('[data-fh-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-fh-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      var lab = b.querySelector('[data-fh-wish-label]');
      if (lab) lab.textContent = on ? 'Saved' : 'Save';
    });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fh-wish]');
    if (!b) return;
    var h = b.getAttribute('data-fh-wish'), list = LS.get(WL), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    LS.set(WL, list.slice(0, 60)); syncWish();
  });
  syncWish();

  var wishPage = document.querySelector('[data-fh-wishlist]');
  if (wishPage) {
    var hs = LS.get(WL);
    if (!hs.length) { wishPage.innerHTML = '<p class="fh-empty">Your wishlist is empty. Tap the ♡ on any piece to save it here.</p><p><a class="fh-link" href="/collections/bags">Discover the collection</a></p>'; }
    else fetchProducts(hs).then(function (ps) { wishPage.innerHTML = '<div class="fh-grid fh-grid--wish">' + ps.map(card).join('') + '</div>'; });
  }

  /* Recently viewed */
  var RV = 'fh_recent', rec = document.querySelector('[data-fh-recent]');
  if (rec) {
    var cur = rec.getAttribute('data-current'), seen = LS.get(RV).filter(function (h) { return h !== cur; });
    var show = seen.slice(0, 8);
    LS.set(RV, [cur].concat(seen).slice(0, 12));
    if (show.length) fetchProducts(show).then(function (ps) {
      if (!ps.length) return;
      rec.querySelector('.fh-grid').innerHTML = ps.map(card).join('');
      rec.hidden = false;
    });
  }

  /* Copy link */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fh-copy]');
    if (!b) return;
    var url = b.getAttribute('data-fh-copy');
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = t; }, 1600);
    }).catch(function () { window.prompt('Copy this link:', url); });
  });

  /* Ask a question -> Shopify Inbox, fallback email */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fh-ask]');
    if (!b) return;
    var title = b.getAttribute('data-title') || document.title;
    var chat = document.querySelector('inbox-online-store-chat');
    var btn = chat && chat.shadowRoot && chat.shadowRoot.querySelector('button');
    if (btn) { btn.click(); return; }
    window.location.href = 'mailto:us@fashionshubs.store?subject=' + encodeURIComponent('Question about ' + title) +
      '&body=' + encodeURIComponent('Hello,\n\nI have a question about: ' + title + '\n' + window.location.href + '\n\n');
  });

  /* Zoom */
  var zoomBox = document.querySelector('[data-fh-zoom-overlay]'), trigger = document.querySelector('[data-fh-zoom]');
  if (zoomBox && trigger) {
    var zimg = zoomBox.querySelector('img'), stage = zoomBox.querySelector('.fh-zoom__stage');
    var open = function () {
      var main = document.getElementById('fhp-main-img'); if (!main) return;
      zimg.src = main.src.replace(/width=\d+/, 'width=2400');
      zoomBox.hidden = false; document.documentElement.style.overflow = 'hidden'; stage.classList.remove('is-zoomed');
    };
    var close = function () { zoomBox.hidden = true; document.documentElement.style.overflow = ''; };
    trigger.addEventListener('click', open);
    trigger.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    zoomBox.querySelector('.fh-zoom__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !zoomBox.hidden) close(); });
    stage.addEventListener('click', function (e) {
      stage.classList.toggle('is-zoomed');
      if (stage.classList.contains('is-zoomed')) {
        var r = stage.getBoundingClientRect();
        zimg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      }
    });
    stage.addEventListener('mousemove', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      var r = stage.getBoundingClientRect();
      zimg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
  }
})();
